// extracted by mini-css-extract-plugin
export default {"form-item":"ChangePassword_form-item__WvQN1","form-item-label":"ChangePassword_form-item-label__HnSpQ"};